module.exports = __webpack_public_path__ + "static/share-image-1695c6e5f2e07766f9c58d39e4223586.jpg";